<template>
  <div class="email-logs-filter p-4">
    <h5 class="mb-4">Filtros</h5>

    <!-- Tipo de Email -->
    <div class="form-group mb-4">
      <label class="mb-2">Tipo de Email</label>
      <select class="form-control" v-model="filters.email_type">
        <option value="">Todos os tipos</option>
        <option value="first_access">Primeiro Acesso</option>
        <option value="add_course">Novo Curso Adicionado</option>
        <option value="access_removed">Acesso Removido</option>
        <option value="reset_password">Reset de Senha</option>
        <option value="recovery_password">Recuperação de Senha</option>
      </select>
    </div>

    <!-- Status -->
    <div class="form-group mb-4">
      <label class="mb-2">Status</label>
      <select class="form-control" v-model="filters.status">
        <option value="">Todos os status</option>
        <option value="sent">Enviado</option>
        <option value="pending">Pendente</option>
        <option value="failed">Falha</option>
      </select>
    </div>

    <!-- Data Início -->
    <div class="form-group mb-4">
      <label class="mb-2">Criado Após</label>
      <input
        type="date"
        class="form-control"
        v-model="filters.created_at__gte"
      />
    </div>

    <!-- Data Fim -->
    <div class="form-group mb-4">
      <label class="mb-2">Criado Antes</label>
      <input
        type="date"
        class="form-control"
        v-model="filters.created_at__lte"
      />
    </div>

    <!-- Botões -->
    <div class="d-flex justify-content-between">
      <button class="btn btn-outline-secondary" @click="clearFilters">
        Limpar
      </button>
      <button class="btn btn-primary" @click="applyFilters">Aplicar</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmailLogsFilter",
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      filters: {
        email_type: "",
        status: "",
        created_at__gte: "",
        created_at__lte: ""
      }
    };
  },
  mounted() {
    this.filters = { ...this.filters, ...this.value };
  },
  methods: {
    clearFilters() {
      this.filters = {
        email_type: "",
        status: "",
        created_at__gte: "",
        created_at__lte: ""
      };
      this.$emit("close");
      this.$emit("submit", {});
    },
    applyFilters() {
      this.$emit("close");
      this.$emit("submit", this.filters);
    }
  }
};
</script>

<style lang="scss" scoped>
.email-logs-filter {
  min-width: 280px;

  label {
    font-weight: 500;
    color: #3b3b4a;
    font-size: 14px;
  }

  .form-control {
    border: 1px solid #d2d0d8;
    border-radius: 4px;
    padding: 8px 12px;

    &:focus {
      border-color: #8636fe;
      box-shadow: 0 0 0 0.2rem rgba(134, 54, 254, 0.25);
    }
  }
}
</style>
